/**
 * Broadcast Channel to support OIDC Events propagation across multiple tabs
 */
export const oidcChannel = new BroadcastChannel("oidc-channel");
